import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "InfoRequest" })
export default class InfoRequest extends Vue {
    public localizer: any = Localizer;
    public isSuccess: boolean = false;
    public formData: any = { vehicleType: null, topic: null };
    public topics: any[] = [];
    public isInfoRequestFormBox: boolean = false;
    public faqs: any = {};

    public isHoliday: boolean = false;
    public redirectUrl: string = null;

    @Watch("formData.topic") onTopicChanged(value: any) {
        if (value) {
            if (value !== undefined) {
                this.getFAQs(value);

                this.isSuccess = false;
            } else {
                this.faqs = {};
                this.formData.topic = null;
                this.isInfoRequestFormBox = false;
            }
        } else {
            this.faqs = {};
            this.isInfoRequestFormBox = false;
        }
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getInfoRequestDataAsync();
    }

    public async getInfoRequestDataAsync() {
        const result = (await Axios.post(this.routes.Support_InfoRequestGetData, null)).data;
        this.isHoliday = result.isHoliday;
        this.redirectUrl = result.redirectUrl;
        this.topics = result.topics;
    }

    public async getFAQs(topic) {
        let faqsResponse = (await Axios.post(this.routes.FAQ_List, { topic: topic })).data;

        if (faqsResponse) {
            this.faqs = faqsResponse;
            this.isInfoRequestFormBox = this.faqs.some((x) => x.faq.isInfoRequest) ? true : false;
        } else {
            this.faqs = {};
        }
    }

    public changeVehicleType() {
        if (this.formData.vehicleType !== 'Car') {
            this.faqs = {};
            this.formData.topic = null;
        }
    }

    public openSupportTicket() {
        GTagHelper.sendEvent("click", "ticket", "open");
        window.location.href = this.routes.MyBremboPartsSupport_NewSupportTicket + "?topic=" + this.formData.topic;
    }

    public setSupportArticleEvent(articleTitle: string) {
        GTagHelper.sendEvent("click", "ticket", "read_article");
    }
};